import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthService } from '@oneComply/core/services/auth.service';

export const loginEntryGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const forcePrompt = route.queryParamMap.get('reauth') === '1';

  authService.clearSession();
  authService.redirectToLogin('/dashboard', forcePrompt);
  return false;
};

